

































































































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import Merchant from "@/store/entities/merchant";
import Ajax from "@/lib/ajax";
import Util from "../../lib/util";

@Component
export default class CreateMerchant extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  merchant: Merchant = new Merchant();
  supplierList: Array<any> = [];

  // 保存
  save() {
    (this.$refs.merchantForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "merchant/update",
          data: this.merchant,
        });
        (this.$refs.merchantForm as any).resetFields();
        this.$Message.success("修改成功");
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }

  validateSupplierId(rule, value, callback) {
    if (!value) {
      return callback(new Error("请选择供应商"));
    } else {
      callback();
    }
  }
  cancel() {
    (this.$refs.merchantForm as any).resetFields();
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }else {
      console.log(
        this.$store.state.merchant.editMerchant,
        "editMerchant"
      );
      this.merchant = Util.extend(
        true,
        {},
        this.$store.state.merchant.editMerchant
      );
    }
  }
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  async created() {
    await this.getSupplierList();
  }
  merchantRule = {
    name: [
      {
        required: true,
        message: "请输入商户名称",
        trigger: "blur",
      },
    ],
    supplierId: [
      { required: true, validator: this.validateSupplierId, trigger: "blur" },
    ],
    appId: [
      {
        required: true,
        message: "请输入AppId",
        trigger: "blur",
      },
    ],
    appKey:[
      {
        required: true,
        message: "请输入AppKey",
        trigger: "blur",
      },
    ],
    mid: [
      {
        required: true,
        message: "请输入商户号",
        trigger: "blur",
      },
    ],
    tid:[
      {
        required: true,
        message: "请输入终端号",
        trigger: "blur",
      },
    ],
  };
}
